import { render, staticRenderFns } from "./SliderNavbar.vue?vue&type=template&id=47772f59&scoped=true"
import script from "./SliderNavbar.vue?vue&type=script&lang=js"
export * from "./SliderNavbar.vue?vue&type=script&lang=js"
import style0 from "./SliderNavbar.vue?vue&type=style&index=0&id=47772f59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47772f59",
  null
  
)

export default component.exports